import type { UserDto } from '@timato/shared';
import { cn } from '@/lib/cn';
import { initialsOf } from '@/lib/initials';
import type { ProjectColor } from '@timato/shared';
import { colorVar, onProjectColor } from '@/lib/projectColors';

type Props = { user: Pick<UserDto, 'name' | 'email' | 'avatarUrl'>; size?: number; /** A teammate's hue; the signed-in user is ink (7a). */ tint?: ProjectColor; className?: string };

/** Photo when there is one, initials otherwise: ink ground for you, a project hue for teammates. */
export function Avatar({ user, size = 26, tint, className }: Props) {
  const style = { width: size, height: size };
  if (user.avatarUrl) return <img src={user.avatarUrl} alt="" style={style} className={cn('rounded-full object-cover shrink-0', className)} />;
  return (
    <span aria-hidden="true" style={{ ...style, fontSize: Math.round(size * 0.42), ...(tint ? { background: colorVar(tint), color: onProjectColor(tint) } : {}) }}
      className={cn('rounded-full grid place-items-center font-extrabold shrink-0', tint ? '' : 'bg-primary-btn-bg text-primary-btn-fg', className)}>
      {initialsOf(user)}
    </span>
  );
}
